export default __webpack_public_path__ + "static/media/image02.402c27d2.jpg";